import React from 'react';
import { PortalUnidadesList } from '../../components/propietario/PortalUnidadesList';

export default function PropietarioRenta() {
  return (
    <PortalUnidadesList
      basePath="/propietario/renta"
      titulo="Renta"
      descripcion="Resumen, facturación y cobro de renta por unidad."
      soloAdministradas
    />
  );
}
